import { createFileRoute, Link } from "@tanstack/react-router";
import { Arrow } from "@/components/icons";
import { routeHead } from "@/components/seo";
import { breadcrumbSchema, personSchema } from "@/lib/schema";
import { pageMeta, brand, site } from "@/content";

const ROUTE = "/about";
export const Route = createFileRoute("/about")({
  head: () =>
    routeHead(ROUTE, {
      jsonLd: [
        personSchema(),
        breadcrumbSchema([
          { name: "Home", item: "/" },
          { name: "About", item: ROUTE },
        ]),
      ],
    }),
  component: Page,
});

const awards = [
  {
    src: "/images/award-luca-2024.webp",
    alt: "NextEra Bookkeeping, LUCA Bookkeeping Awards 2024 finalist badge",
    w: 320,
    h: 320,
  },
  {
    src: "/images/award-wifa-2025.webp",
    alt: "Jamee White, CPA, Women in Finance Awards 2025 finalist badge",
    w: 320,
    h: 303,
  },
  {
    src: "/images/award-wifa-2024.webp",
    alt: "Jamee White, CPA, Women in Finance Awards 2024 finalist badge",
    w: 320,
    h: 303,
  },
  {
    src: "/images/award-wia-2024.webp",
    alt: "Jamee White, CPA, Women in Accounting Awards 2024 finalist badge",
    w: 320,
    h: 320,
  },
];

function Page() {
  const p = pageMeta(ROUTE)!;
  return (
    <div className="bg-background text-foreground">
      <section className="border-b border-line">
        <div className="mx-auto grid max-w-6xl gap-12 px-6 py-20 md:grid-cols-[1fr_1fr] md:py-24">
          <div>
            <h1 className="hero-enter mt-4 font-serif text-4xl leading-[1.1] text-ink sm:text-5xl">
              {p.h1}
            </h1>
            <p className="hero-enter-delay mt-6 text-lg leading-relaxed text-ink/80">
              {brand.supportingCopy}
            </p>
            <p className="hero-enter-delay mt-4 leading-relaxed text-ink/80">
              Most businesses don't need someone to enter transactions. They need someone who can
              tell them what those transactions actually mean. That's the gap between a bookkeeper
              and a finance function, and it's the one Jamee built NextEra to close.
            </p>
            <div className="hero-enter-delay mt-8">
              <Link to={site.primaryCta.href} className="btn-primary">
                {site.primaryCta.label}
                <Arrow className="h-4 w-4" />
              </Link>
            </div>
          </div>
          <div className="photo-frame hero-enter-delay">
            <img
              src="/images/jamee.webp"
              alt="Portrait of Jamee White, CPA, founder of NextEra"
              width="800"
              height="1000"
              className="w-full object-cover"
            />
          </div>
        </div>
      </section>

      <section className="bg-background">
        <div className="mx-auto max-w-6xl px-6 py-16">
          <div className="stagger mt-6 flex flex-wrap items-center gap-10">
            {awards.map((a) => (
              <img
                key={a.src}
                src={a.src}
                alt={a.alt}
                width={a.w}
                height={a.h}
                className="float-y h-16 w-auto"
                loading="lazy"
              />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
